import { render, staticRenderFns } from "./Denied.vue?vue&type=template&id=ccd05950&"
import script from "./Denied.vue?vue&type=script&lang=js&"
export * from "./Denied.vue?vue&type=script&lang=js&"
import style0 from "./Denied.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports